import store from '../store';
import { removeToast } from '../store/actions/toasts';

const removePending = (pendingId) => {
  store.dispatch(removeToast(pendingId));
};

export default removePending;
